import React from 'react'

import './styles.css'
import './gallery.theme.css'
import './gallery.min.css'
import './bootstrap.css'

import BarHOME from '../components/BarHOME'
import Header from '../components/Header'
import NavBar1 from '../components/NavBar1'
import Gallery from '../components/Gallery'
import Footer from '../components/Footer'
import Card6 from '../components/Card6'
import Helmet from 'react-helmet'
import Card from '../components/Card'




const Index = () => {
    return (
        
         <div className='font-al-8'>
            <Helmet>
                <title>Celeste Bolos Doces & Salgados - Home</title>
            </Helmet>
            <BarHOME />
            <NavBar1/>
            <Gallery/>
            <Header />
            <Card6/>
            <Card/>
        
            {/*<Periciatrabalhista/>*/}
            <Footer />

        </div>
        
       
    )
}
export default Index